import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GtmService } from "../service/gtm/gtm.service";

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  terms: string;

  constructor(private route: ActivatedRoute,
    private gtmService: GtmService) {
    this.terms = termsText;

    this.gtmService.pageViewWithPage({
      'path': this.route.snapshot['_routerState'].url,
      'title': '이용안내',
      'breadcrumb': 'Home > 이용안내'
    });
  }

  ngOnInit() {
  }

}

export const termsSimpleText = `
<br />
<p><b>"헤이그라운드 멤버십 가입 신청을 위한 개인정보 제공 이용 동의" </b></p>
<br />
<p><u class="larger">사단법인 루트임팩트에서 운영하는 헤이그라운드</u>는 [개인정보보호법] 제15조에 근거하여 개인정보 수집 및 이용에 대한 동의를 받고 있습니다. 수집된 개인정보 - 이름, 전화번호, 이메일 주소 - 는 <u class="larger">헤이그라운드 멤버십 가입 절차 진행 및 결과 안내</u>를 위해서만 사용되며, 멤버십 가입 신청서 제출 <u class="larger">12개월</u> 후 폐기됩니다. 개인정보의 수집 및 이용에 대한 동의를 거부할 수 있으며 이 경우 멤버십 가입 신청서 제출이 불가능합니다.</p>
<br />
`;

export const termsText = `
<br>
<p>'(사)루트임팩트 - 헤이그라운드 투어 서비스' 이하 ‘회사의 서비스'는 개인정보 보호법 제 30조에 따라 정보주체의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 수립 및 공개합니다.
<br>
해당 개인정보 처리방침은 헤이그라운드 투어 서비스와 관련된 내용에 한해 적용됩니다.<br>
‘회사의 서비스’는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.<br>
<br>
○ 본 방침은 2019년 10월 7일부터 시행됩니다.
</p>
<br>
<h5>제1조 개인정보의 처리목적</h5>
<p>‘회사의 서비스’는 개인정보를 다음의 목적을 위해 처리합니다. 처리하고 있는 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 개인정보 보호법 제 18조에 따라 별도의 사전동의를 구할 예정입니다.<p>
<br>
<p>
1. 재화 또는 서비스 제공<br>
-투어서비스 제공 등을 목적으로 개인정보를 처리합니다.<br>
-모바일 출입증(QR코드) 발송, 본인 확인, 불만 처리 등 원활한 의사소통 경로의 확보 및 분쟁조정을 위한 기록보존 등<br>
-통계학적 분석(이용자의 서비스 이용에 대한 통계분석, 웹로그분석 등)
-서비스, 마케팅 정보의 안내<br>
<p>
<br>

<h5>제2조 개인정보의 처리 및 보유기간</h5>
<p>① ‘회사의 서비스’는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집시에 동의 받은 개인정보 보유,이용기간 내에서 개인정보를 처리,보유합니다.</p>
<p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
<br>
<p>
1. 재화 또는 서비스 제공 : 투어 서비스 제공완료시까지 다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료시까지<br>
<br>
1) 전자상거래 등에서의 소비자 보호에 관한 법률에 따른 표시·광고, 계약내용 및 이행 등 거래에 관한 기록<br>
-보유근거 : 소비자의 불만 또는 분쟁처리에 관한 기록<br>
-관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년<br>
</p>
<br>

<h5>제3조 정보주체와 법정대리인의 권리·의무 및 행사방법</h5>
<p>①정보주체는 ‘회사의 서비스’는 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.</p>
<p>②제 1항에 따른 권리 행사는 ‘회사의 서비스’에 대해 개인정보보호법 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, ‘회사의 서비스’는 이에 대해 지체없이 조치하겠습니다.</p>
<p>③제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제 11호 서식에 따른 위임장을 제출하셔야 합니다. </p>
<p>④개인정보 열람 및 처리정지 요구는 개인정보보호법 제 35조 제5항, 제37조 제 2항에 의하여 정보주체의 권리가 제한 될 수 있습니다. </p>
<p>⑤개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
<p>⑥’회사의 서비스’는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다. </p>
<br>

<h5>제4조 처리하는 개인정보 항목</h5>
<p>‘회사의 서비스’는 다음의 개인정보 항목을 처리하고 있습니다.</p>
<br>
<p>
1.재화 또는 서비스 제공<br>
-필수항목 : 투어 지점, 방문일정, 이름, 이메일 주소, 휴대폰 번호, 방문인원, 방문사유<br>
-선택항목 : 투어 신청내역  <br>
<br>
2. 인터넷 서비스 이용과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다.<br>
-IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등<br>
</p>
<br>

<h5>제5조 개인정보의 파기</h5>
<p>①’회사의 서비스’는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</p>
<p>②정보주체로부터 동의받은 개인정보 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</p>
<p>③개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
<br>
<p>
1.파기절차<br>
‘회사의 서비스’는 파기 사유가 발생한 개인정보를 선정하고 ‘회사의 서비스’의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.또는 정보주체가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.<br>
</p>
<p>
2.파기방법<br>
‘회사의 서비스’는 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.<br>
종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.<br>
</p>
<br>

<h5>제6조 개인정보의 안전성 확보 조치</h5>
<p>‘회사의 서비스’ 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</p>
<br>
<p>
1. 관리적 조치 : 내부관리계획 수립 및 시행, 정기적 직원 교육 등<br>
2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화<br>
3. 물리적 조치 : 전산실 등의 접근통제<br>
</p>
<br>

<h5>제7조 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항</h5>
<p>① ‘회사의 서비스’는 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.</p>
<p>② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다. </p>
<p>
가. 쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.
나. 쿠키의 설치•운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.
다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.
</p>
<br>

<h5>제8조 개인정보 보호책임자 작성</h5>
<p>①’회사의 서비스’는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
<br>

<p>
▶ 개인정보 보호책임자<br>
<br>
<br>
성명 :허재형<br>
소속 :루트임팩트<br>
직책 :대표<br>
<br>
※ 개인정보 보호 담당부서로 연결됩니다.<br>
<br>
<br>
▶ 개인정보 보호 담당부서<br>
<br>
부서명 : 헤이그라운드 성수 시작점 커뮤니티 팀<br>
담당자 :이형우<br>
연락처 :02-6495-0182<br>
E-mail :hw.yi@rootimpact.org<br>
<br>
<br>
부서명 :헤이그라운드 서울숲점 커뮤니티 팀<br>
담당자 :최병주<br>
연락처 :02-6495-0282<br>
E-mail: bj.choi@rootimpact.org<br>
<br>
<br>
② 정보주체께서는 루트임팩트(‘HEYGROUND.COM’이하 ‘헤이그라운드) 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 루트임팩트(‘HEYGROUND.COM’이하 ‘헤이그라운드) 은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
</p>
<br>

<h5>제9조 개인정보 처리방침 변경</h5>
<p>
①이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
</p>
<br>
`;


// WEBPACK FOOTER //
// ./src/app/terms/terms.component.ts